import { z } from 'zod';
// ── Calendar engine: generic dated events ───────────────────────────────────
// A calendar event is a date (or date range, optionally with times) that can stand alone or be
// associated with an opportunity (audition), a client, and/or a media item. It NEVER overwrites
// an audition's own due_date / pinned hold — it's an additive layer on the shared calendar.
const TIME_RE = /^[0-2][0-9]:[0-5][0-9]$/;
const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
export const calendarEventInputSchema = z
    .object({
    title: z.string().trim().min(1).max(200),
    note: z.string().max(4000).optional().nullable(),
    /** Associated stage key (built-in like 'pinned' or a c_* custom key); free-form, validated lax. */
    stage: z.string().max(40).optional().nullable(),
    start_date: z.string().regex(ISO_DATE_RE, 'start_date must be YYYY-MM-DD'),
    end_date: z.string().regex(ISO_DATE_RE).optional().nullable(),
    start_time: z.string().regex(TIME_RE).optional().nullable(),
    end_time: z.string().regex(TIME_RE).optional().nullable(),
    /** Optional associations — the server asserts each belongs to the business. */
    client_id: z.string().uuid().optional().nullable(),
    opportunity_id: z.string().uuid().optional().nullable(),
    media_id: z.string().uuid().optional().nullable(),
    /** Optional custom event TYPE (colour + legend category); the server asserts it's this business's. */
    event_type_id: z.string().uuid().optional().nullable(),
})
    .refine((v) => !v.end_date || v.end_date >= v.start_date, { message: 'end_date must be on or after start_date', path: ['end_date'] });
/** Patch: any subset of the input (associations + dates + text). */
export const calendarEventPatchSchema = z
    .object({
    title: z.string().trim().min(1).max(200).optional(),
    note: z.string().max(4000).optional().nullable(),
    stage: z.string().max(40).optional().nullable(),
    start_date: z.string().regex(ISO_DATE_RE).optional(),
    end_date: z.string().regex(ISO_DATE_RE).optional().nullable(),
    start_time: z.string().regex(TIME_RE).optional().nullable(),
    end_time: z.string().regex(TIME_RE).optional().nullable(),
    client_id: z.string().uuid().optional().nullable(),
    opportunity_id: z.string().uuid().optional().nullable(),
    media_id: z.string().uuid().optional().nullable(),
    event_type_id: z.string().uuid().optional().nullable(),
});
// ── Custom calendar event TYPES ─────────────────────────────────────────────
// Agency-defined, reusable date categories that populate the calendar "+" add menu and colour
// their events + legend. Each carries field DEFAULTS applied when you create an event of that type.
const HEX_RE = /^#[0-9a-fA-F]{6}$/;
export const calendarEventTypeInputSchema = z.object({
    label: z.string().trim().min(1).max(60),
    color: z.string().regex(HEX_RE, 'color must be a #rrggbb hex').optional().nullable(),
    all_day: z.boolean().optional(),
    default_start_time: z.string().regex(TIME_RE).optional().nullable(),
    default_end_time: z.string().regex(TIME_RE).optional().nullable(),
    note_template: z.string().max(4000).optional().nullable(),
    sort_order: z.number().int().optional(),
});
/** Patch: any subset of the create fields. */
export const calendarEventTypePatchSchema = calendarEventTypeInputSchema.partial();
//# sourceMappingURL=calendar.js.map